import script from "./SidePanelEIA.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelEIA.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelEIA.vue?vue&type=style&index=0&id=eb66db82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb66db82"]])

export default __exports__